import React, { useEffect, useState } from "react";
import downloadIcon from "../../assets/card-icons/download-black.svg";
import closeIcon from "../../assets/close.svg";
import deleteIcon from "../../assets/delete-grey.svg";
import editPencil from "../../assets/edit-pencil.svg";
import eyeIcon from "../../assets/eye-icon.svg";
import Alert from "../../components/Alert/Alert";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import InfoCard from "../../components/Cards/InfoCard";
import MainContainer from "../../components/container/MainContainer";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDocViewer from "../../components/CustomDocViewer/CustomDocViewer";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import InputField from "../../components/InputField/InputField";
import Orders from "../../components/Orders/Orders";
import useInputValidation from "../../hooks/useInputValidation";
import usePagination from "../../hooks/usePagination";
import { getDetails, postDetails } from "../../services/http/http.service";
import { setActionableAlert, setAlertMode, setMessage, setShowAlert } from "../../store/Alert/alert.slice";
import { setUser } from "../../store/authentication/authentication.slice";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { setPageData, setPageNumber } from "../../store/pageData/pageData.slice";
import { setOrderTab } from "../../store/selectedAPIs/selectedAPIs.slice";
import { useAppDispatch, useAppSelector } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import BreadcrumbData from "../../utils/constants/BreadcrumbData.constants";
import formatDate from "../../utils/constants/formatDate";
import { APIResponseCodes } from "../../utils/constants/keys.constants";
import StoreSelectors from "../../utils/constants/StoreSelectors.constants";
import openURL from "../../utils/helpers/openURL";
import setInputValues from "../../utils/helpers/setInputValue";
import { isAlphaNumeric } from "../../utils/helpers/stringFormatTest";
import transformString from "../../utils/helpers/transformString";
import Requests from "../requests/Requests";
import "./profile-page.css";
import Invoices from "./UI-Components/Invoices";
import { message } from "../../utils/constants/Messages";

type RegionCode = {
  id: number;
  state_name: string;
  region_code: string;
};

const ProfilePage: React.FunctionComponent<any> = () => {
  const options = [
    { id: 1, label: "general" },
    { id: 2, label: "Orders" },
    { id: 3, label: "Billing Information" },
  ];

  const dispatch = useAppDispatch();
  const { bindValue } = useInputValidation();

  const { user, primaryUser, canAddUsers, access, uatKey, prodKey } = useAppSelector(StoreSelectors.USER_STATE);

  const [tabOptions, setTabOptions] = useState({ id: 1, label: "general" });
  const [showGenSubmitBtn, setShowGenSubmitBtn] = useState(false);
  const [showComplianceSubmitBtn, setShowComplianceSubmitBtn] = useState(false);
  const [regionCodes, setRegionCodes] = useState<RegionCode[]>([]);
  const [showRegionDropdown, setShowRegionDropdown] = useState(false);



  /** Form input states starts*/

  const [generalFormInputs, setGeneralFormInputs] = useState({
    organisation_name: "",
    email: "",
    phone_number: "",
    ria: "",
    arn: "",
    pan: "",
  });

  const [generalFormInputsCopy, setGeneralFormInputsCopy] = useState({
    organisation_name: "",
    email: "",
    phone_number: "",
    ria: "",
    arn: "",
    pan: "",
  });

  const [editableFields, setEditableFields] = useState({
    phone_number: false,
    ria: false,
    arn: false,
    pan: false,
  });
  const [editableComplianceFields, setEditableComplianceFields] = useState({
  arn: false,
  pan: false,
  gstin: false,
  region_code: false,
});

  const [editableBillingFields, setEditableBillingFields] = useState({
    pan: false,
    gstin: false,
    signatory: false,
    address: false,
  });

  const [currentTabOption, setCurrentTabOption] = useState("uat" as "uat" | "prod");
  const [newUser, setNewUser] = useState({ id: Date.now(), value: "" });
  const [updateValues, setUpdateValues] = useState<Array<any>>([]);
  const [prodUsers, setProdUsers] = useState([] as Array<any>);
  const [uatUsers, setUATUsers] = useState([] as Array<any>);
  const [addedUsers, setAddedUsers] = useState({} as any);
  const [originalData, setOriginalData] = useState({} as any);
  const [err, setErr] = useState({ show: false, message: "" });
  const [accessUpdateMode, setAccessUpdateMode] = useState({ active: false, updateMail: "" });
  const [accessDelete, setAccessDelete] = useState({ id: 0, email: "" });
  const [errMessage, setErrMessage] = useState("");
  const [allAgreements, setAllAgreements] = useState([] as Array<any>);
  const [fileToView, setFileToView] = useState("");

  /** Billing states */
  const [billingDetails, setBillingDetails] = useState({
    pan: "",
    gstin: "",
    signatory: "",
    address: "",
  });
  const [billingCopyFormInputs, setbillingCopyFormInputs] = useState({
    pan: "",
    gstin: "",
    signatory: "",
    address: "",
  });

  //compliance
  const [complianceDetails, setComplianceDetails] = useState({
  arn: "",
  pan: "",
  gstin: "",
  region_code: "",
});
 const [complianceCopyFormInputs, setcomplianceCopyFormInputs] = useState({
  arn: "",
  pan: "",
  gstin: "",
  region_code: "",
});
  const [showUATToken, setShowUATToken] = useState({ show: false, token: "", copied: false });
  const [showProdToken, setShowProdToken] = useState({ show: false, token: "", copied: false });

  /** Prepare pagination data  */
  const { currentItems, handlePageClick, itemsPerPage, pageCount, pageNumber, itemOffset, setItemOffset } = usePagination({
    items: currentTabOption === "uat" ? Object.values(uatUsers) : Object.values(prodUsers),
    from: "access",
  });

  /** Get all users */
  const getAllUsers = async (tab: "uat" | "prod") => {
    dispatch(showLoader(message.GETTING_DETAILS));
    dispatch(setPageNumber(0));
    setItemOffset(0);
    try {
      const response = await getDetails(tab === "prod" ? APIList.GET_PROD_USERS : APIList.GET_UAT_USERS, () => getAllUsers(tab));

      if (response.statusCode === APIResponseCodes.SUCCESS) {
        if (response.data.resList.length !== 0) {
          tab === "prod" ? setProdUsers(response.data.resList) : setUATUsers(response.data.resList);
          setOriginalData(response.data.resList);
        }
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
    }
  };

//   const getRegionCodes = async () => {
//   const response = await getDetails(APIList.USER_REGION_CODES, getRegionCodes);

//   if (response?.statusCode === APIResponseCodes.SUCCESS) {
//     setRegionCodes(Array.isArray(response.data) ? response.data : []);
//   }
// };

  /** Getting Billing details */
  const getBillings = async () => {
    dispatch(showLoader(message.GETTING_DETAILS));

    try {
      const response = await getDetails(APIList.USER_BILLING_DETAILS, getBillings);
      dispatch(hideLoader());
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        setBillingDetails({
          address: response.data.billing_address,
          gstin: response.data.gstin,
          pan: response.data.pan,
          signatory: response.data.authorised_signatory,
        });
        setbillingCopyFormInputs({
          address: response.data.billing_address,
          gstin: response.data.gstin,
          pan: response.data.pan,
          signatory: response.data.authorised_signatory,
        });
     setComplianceDetails({
  gstin: response.data.gstin || "",
  pan: response.data.pan || "",
  arn: response.data.arn_code || "",
  region_code: normalizeRegionCode(response.data.region_code),
});

setcomplianceCopyFormInputs({
  gstin: response.data.gstin || "",
  pan: response.data.pan || "",
  arn: response.data.arn_code || "",
  region_code: normalizeRegionCode(response.data.region_code),
});
      }
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
    }
  };

  /** Get all agreements */
  const getAgreements = async () => {
    const response = await getDetails(APIList.USER_AGREEMENTS, getAgreements);
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      setAllAgreements(response.data.data);
    }
  };

  useEffect(() => {
    if (tabOptions.label === "general") {
      setGeneralFormInputs({
        email: user?.email || "",
        organisation_name: user?.organization_name || "",
        phone_number: user?.phone_number || "",
        arn: user?.sebi_code || "",
        pan: user?.pan || "",
        ria: user?.rbi_code || "",
      });
      setShowUATToken({ ...showUATToken, token: uatKey });
      setShowProdToken({ ...showProdToken, token: prodKey });
      getBillings();
      // getRegionCodes();
    }

    if (tabOptions.label.toLowerCase() === "billing information") {
      getBillings();
      getAgreements();
    }
  }, [user, tabOptions]);

  useEffect(() => {
    const genDetails = {
      email: user?.email || "",
      organisation_name: user?.organization_name || "",
      phone_number: user?.phone_number || "",
      arn: user?.sebi_code || "",
      pan: "",
      ria: user?.rbi_code || "",
    };

    if (JSON.stringify(generalFormInputs) !== JSON.stringify(genDetails)) {
      setShowGenSubmitBtn(true);
    } else {
      setShowGenSubmitBtn(false);
    }

    setErrMessage("");
  }, [generalFormInputs, billingDetails]);

  useEffect(() => {
  if (JSON.stringify(complianceDetails) !== JSON.stringify(complianceCopyFormInputs)) {
    setShowComplianceSubmitBtn(true);
  } else {
    setShowComplianceSubmitBtn(false);
  }
}, [complianceDetails, complianceCopyFormInputs]);

  /** Post edited general information of user */
  const saveUserGeneralDetails = async () => {
    // const arnRegex = /^ARN-\d{4,6}$/i;
    const arnRegex = /^(ARN|INA|EOP)-?\d+$/i;
    if (editableFields.phone_number === true && (generalFormInputs.phone_number.length < 10 || !generalFormInputs.phone_number.match(/[0-9]+$/))) {
      setErrMessage("Invalid phonenumber");
      return;
    } else if (user.registered_with_sebi && editableFields.arn === true && 
      // (generalFormInputs.arn.length < 8 || !isAlphaNumeric(generalFormInputs.arn))
      !arnRegex.test(generalFormInputs.arn)
    ) {
      setErrMessage("Invalid ARN code");
      return;
    } else if (user.registered_with_rbi && editableFields.ria === true && (generalFormInputs.ria.length < 8 || !isAlphaNumeric(generalFormInputs.ria))) {
      setErrMessage("Invalid RIA code");
      return;
    } else if (editableFields.pan === true && (generalFormInputs.pan.length !== 10 || !isAlphaNumeric(generalFormInputs.pan))) {
      setErrMessage("Invalid PAN number");
      return;
    }

    if (!Object.values(editableFields).includes(true)) {
      discardChanges();
      return;
    }

    dispatch(showLoader(message.UPDATING_DETAILS));
    const payload = {
      phone_number: editableFields.phone_number ? parseInt(generalFormInputs.phone_number) : parseInt(generalFormInputsCopy.phone_number),
      ria_code: editableFields.ria ? generalFormInputs.ria : generalFormInputsCopy.ria,
      arn_code: editableFields.arn ? generalFormInputs.arn : generalFormInputsCopy.arn,
      pan: editableFields.pan ? generalFormInputs.pan : generalFormInputsCopy.pan,
    };

    const response = await postDetails(APIList.USER_SAVE_GENERAL, payload, saveUserGeneralDetails);

    dispatch(hideLoader());
    if (response.statusCode === APIResponseCodes.SUCCESS) {
      const res = {
        organisation_name: response.data.organization_name,
        phone_number: `${response.data.phone_number}`,
        ria: response.data.ria_code,
        arn: response.data.arn_code,
        pan: response.data.pan,
        email: user?.email || "",
      };
      setGeneralFormInputs(res);
      setGeneralFormInputsCopy(res);
      setEditableFields({
        phone_number: false,
        ria: false,
        arn: false,
        pan: false,
      });
      dispatch(
        setUser({
          ...user,
          sebi_code: response.data.arn_code,
          rbi_code: response.data.ria_code,
          organization_name: response.data.organization_name,
          phone_number: `${response.data.phone_number}`,
          pan: response.data.pan,
        }),
      );
    }
  };

  //compliance  detils Update
  const saveComplianceGeneralDetails = async () => {
    // const arnRegex = /^ARN-\d{4,6}$/i
    const arnRegex = /^(ARN|INA|EOP)-?\d+$/i;
    // validations
    if (editableComplianceFields.pan === true && (complianceDetails.pan.length !== 10 || !isAlphaNumeric(complianceDetails.pan))) {
      setErrMessage("Invalid PAN number");
      return;
    }

    if (editableComplianceFields.arn === true &&
      //  (complianceDetails.arn.length !== 8 || !isAlphaNumeric(complianceDetails.arn))
      !arnRegex.test(complianceDetails.arn)

      ) {
      setErrMessage("Invalid ARN/RIA/EOP");
      return;
    }

    if (editableComplianceFields.gstin === true && (complianceDetails.gstin.length !== 15 || !isAlphaNumeric(complianceDetails.gstin))) {
      setErrMessage("Invalid GST number");
      return;
    }

    if (!Object.values(editableComplianceFields).includes(true)) {
      discardChanges();
      return;
    }

    dispatch(showLoader(message.UPDATING_DETAILS));

    const payload = {
      ria_code: editableComplianceFields.pan ? complianceDetails.pan : complianceCopyFormInputs.pan,
      gstin: editableComplianceFields.gstin ? complianceDetails.gstin : complianceCopyFormInputs.gstin,
      arn_code: editableComplianceFields.arn ? complianceDetails.arn : complianceCopyFormInputs.arn,
        region_code: editableComplianceFields.region_code ? complianceDetails.region_code : complianceCopyFormInputs.region_code,

    };

    try {
      const response = await postDetails(APIList.USER_SAVE_BILLING_DETAILS, payload, saveComplianceGeneralDetails);
      dispatch(hideLoader());

      if (response.statusCode === APIResponseCodes.SUCCESS) {
        // update local copies to what server returned (keeps parity with general flow)
        const updatedCompliance = {
  pan: response.data.pan || payload.ria_code,
  gstin: response.data.gstin || payload.gstin,
  arn: response.data.arn_code || payload.arn_code,
  region_code: response.data.region_code || payload.region_code,
};
        setComplianceDetails(updatedCompliance);
        setcomplianceCopyFormInputs(updatedCompliance);

        // clear editable flags for compliance block only
       setEditableComplianceFields({
  pan: false,
  gstin: false,
  arn: false,
  region_code: false,
})

        // if API returns organization/user-level details you want to update in store,
        // dispatch(setUser(...)) here similar to saveUserGeneralDetails
      }
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
    }
  };

  /** Handle tab selection */
  const handleSelection = async (item: { id: number; label: string }) => {
    if (item.id !== tabOptions.id) {
      setAddedUsers({});
      setUpdateValues([]);
      setErrMessage("");
      dispatch(setPageData([]));
      if (item.label === "Orders") {
        dispatch(setOrderTab("uat"));
      }
      if (item.id === 5) {
        await getAllUsers("uat");
      }
      setTabOptions(item);
      setItemOffset(0);
      dispatch(setPageNumber(0));
      resetUpdate();
    }
  };

  /** */
  const handleInputEdit = (ev: any) => {
    const name = ev.target.name;
    if (tabOptions.label.toLowerCase() === "billing information") {
      setEditableBillingFields({ ...editableBillingFields, [ev.target.name]: true });
      return;
    }

    // General tab: PAN / GSTIN are treated as compliance fields
    if (tabOptions.label.toLowerCase() === "general") {
     if (name === "pan" || name === "gstin" || name === "arn" || name === "region_code") {
  setEditableComplianceFields({ ...editableComplianceFields, [name]: true });

  if (name === "region_code") {
    setShowRegionDropdown(true);
  }

  return;
}
      // Other general fields
      setGeneralFormInputsCopy(generalFormInputs);
      setEditableFields({ ...editableFields, [name]: true });
      return;
    }

    setGeneralFormInputsCopy(generalFormInputs);
    setEditableFields({ ...editableFields, [ev.target.name]: true });
  };

  const discardChanges = () => {
    if (tabOptions.label.toLowerCase() === "billing information") {
      setEditableBillingFields({ address: false, gstin: false, pan: false, signatory: false });
      setBillingDetails(billingCopyFormInputs);
      return;
    }
    if (Object.values(editableComplianceFields).includes(true)) {
      setEditableComplianceFields({ gstin: false, pan: false, arn: false , region_code: false});
      setComplianceDetails(complianceCopyFormInputs);
      setShowRegionDropdown(false);

      return;
    }
    setGeneralFormInputs(generalFormInputsCopy);
    setEditableFields({
      phone_number: false,
      ria: false,
      arn: false,
      pan: false,
    });
  };

  const changeTab = (tab: "uat" | "prod") => {
    setItemOffset(0);
    dispatch(setPageNumber(0));
    setErr({ show: false, message: "" });
    setCurrentTabOption(tab);
    setNewUser({ id: Date.now(), value: "" });
    setAccessUpdateMode({ active: false, updateMail: "" });
    setUpdateValues([]);
    setAddedUsers({});
    getAllUsers(tab);
  };

  const resetUpdate = () => {
    setErr({ show: false, message: "" });
    setAccessUpdateMode({ active: false, updateMail: "" });
    setNewUser({ id: Date.now(), value: "" });
  };

  /** Insert email id to table */

  const handleAddField = () => {
    setErr({ show: false, message: "" });
    const subdomain = typeof user.email === "string" ? user.email.split("@")[1].split(".")[0] : "";
    const userSubdomain = newUser.value.includes("@") ? newUser.value.split("@")[1].split(".")[0] : null;
    let fieldValid = true;

    if (currentTabOption === "uat") {
      if (uatUsers.length >= 49) {
        setErr({ show: true, message: "Maximum users limit reached and can't add more users." });
        return;
      }

      uatUsers.forEach((user: any) => {
        if (transformString(user.email, " ", "") === transformString(newUser.value, " ", "")) {
          fieldValid = false;
        }
      });
    }

    if (currentTabOption === "prod") {
      if (prodUsers.length >= 19) {
        setErr({ show: true, message: "Maximum users limit reached and can't add more users." });
        return;
      }

      prodUsers.forEach((user: any) => {
        if (transformString(user.email, " ", "") === transformString(newUser.value, " ", "")) {
          fieldValid = false;
        }
      });
    }

    if (!fieldValid) {
      setErr({ show: true, message: "Email ID already exists" });
      return;
    }

    if (newUser.value.length === 0 || !newUser.value.match(/^[a-zA-Z0-9._%+-]+[a-zA-Z0-9]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      setErr({ show: true, message: "Invalid Email ID" });
      return;
    }

    if (subdomain !== userSubdomain) {
      setErr({ show: true, message: "Email ID is not from your organization" });
      return;
    }

    if (user.email.trim().toLowerCase() === newUser.value.trim().toLowerCase()) {
      setErr({ show: true, message: "User Email ID can't be your Email ID" });
      return;
    }

    if (accessUpdateMode.active) {
      if (currentTabOption === "uat") {
        const editedUsers: Array<any> = [];
        const allUsers: Array<any> = [];

        uatUsers.forEach((user) => {
          user.email.toLowerCase().trim() === accessUpdateMode.updateMail.toLowerCase().trim() ? editedUsers.push({ id: user.id, email: newUser.value }) : allUsers.push(user);
        });
        setUATUsers([...editedUsers, ...allUsers]);
      }

      if (currentTabOption === "prod") {
        const editedUsers: Array<any> = [];
        const allUsers: Array<any> = [];

        prodUsers.forEach((user) => {
          user.email.toLowerCase().trim() === accessUpdateMode.updateMail.toLowerCase().trim() ? editedUsers.push({ id: user.id, email: newUser.value }) : allUsers.push(user);
        });
        setProdUsers([...editedUsers, ...allUsers]);
      }

      setUpdateValues([...updateValues, newUser]);
      setAccessUpdateMode({ active: false, updateMail: "" });
      setNewUser({ id: Date.now(), value: "" });
      resetUpdate();
      return;
    }

    if (!accessUpdateMode.active) {
      currentTabOption === "prod" ? setProdUsers([{ id: newUser.id, email: newUser.value }, ...prodUsers]) : setUATUsers([{ id: newUser.id, email: newUser.value }, ...uatUsers]);
      setAddedUsers({ ...addedUsers, [newUser.id]: newUser.value.toLowerCase() });
      setNewUser({ id: Date.now(), value: "" });
      return;
    }
  };

  /** Handle field edit */
  const handleUserEdit = (editData: { id: number; email: string }) => {
    setAccessUpdateMode({ active: true, updateMail: editData.email.toLowerCase() });
    setNewUser({ id: editData.id, value: editData.email });
  };

  const handleUsersSubmit = async () => {
    let payload: Array<any> = [];

    let addedUserKeys = Object.keys(addedUsers);
    const newUserEdited: Array<number> = [];

    if (updateValues.length !== 0) {
      updateValues.forEach((item) => {
        if (addedUserKeys.includes(`${item.id}`)) {
          payload.push({ email: item.value });
          newUserEdited.push(item.id);
        } else {
          payload.push({ id: item.id, email: item.value });
        }
      });
    }

    if (Object.values(addedUsers).length !== 0) {
      addedUserKeys.forEach((key) => {
        if (!newUserEdited.includes(parseInt(key))) {
          payload.push({ email: addedUsers[key] });
        }
      });
    }

    if (currentTabOption === "uat") {
      const response = await postDetails(APIList.POST_UAT_USER, { emailList: payload }, handleUsersSubmit);
      dispatch(hideLoader());
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        setUpdateValues([]);
        setAddedUsers({});
        getAllUsers("uat");
      }
    }

    if (currentTabOption === "prod") {
      const response = await postDetails(APIList.POST_PROD_USER, { emailList: payload }, handleUsersSubmit);
      dispatch(hideLoader());
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        setUpdateValues([]);
        setAddedUsers({});
        getAllUsers("prod");
      }
    }
  };

  /** Delete an user object locally when user clicks on delete  */
  const deleteLocal = (id: number) => {
    let tempUsers: Array<any> = [];
    let tempAddedUsers = {};

    if (currentTabOption === "uat") {
      tempUsers = uatUsers.filter((item) => id !== item.id);
    }

    if (currentTabOption === "prod") {
      tempUsers = prodUsers.filter((item) => id !== item.id);
    }

    Object.keys(addedUsers).forEach((key) => {
      if (parseInt(key) !== id) {
        tempAddedUsers = { ...tempAddedUsers, [key]: addedUsers[key] };
      }
    });

    setItemOffset(0);
    dispatch(setPageNumber(0));
    currentTabOption === "uat" ? setUATUsers(tempUsers) : setProdUsers(tempUsers);
    setAddedUsers(tempAddedUsers);
  };

  /** Manage access - delete user */
  const deleteUser = async () => {
    try {
      dispatch(showLoader(message.DELETING_USER));
      const response = await postDetails(currentTabOption === "prod" ? APIList.DELETE_PROD_USER : APIList.DELETE_UAT_USER, { email: accessDelete.email }, deleteUser);
      if (response.statusCode === APIResponseCodes.SUCCESS) {
        deleteLocal(accessDelete.id);
        setAccessDelete({ id: 0, email: "" });
        dispatch(setActionableAlert(false));
        dispatch(setAlertMode(true));
        dispatch(setMessage(message.USER_ACCESS_REMOVED));
        dispatch(setShowAlert(true));
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
    }
  };

  /** Delete an input box */
  const handleFieldDelete = (user: { id: number; email: string }) => {
    if (Object.values(addedUsers).includes(user.email.toLowerCase())) {
      deleteLocal(user.id);
      return;
    }

    setAccessDelete({ id: user.id, email: user.email });
    dispatch(setActionableAlert(true));
    dispatch(setAlertMode(true));
    dispatch(setMessage(message.CONFIRM_USER_ACCESS_REMOVED));
    dispatch(setShowAlert(true));
  };

  /** Discard Access management changes*/
  const discardAccessChanges = () => {
    setNewUser({ id: Date.now(), value: "" });
    setAccessUpdateMode({ active: false, updateMail: "" });
    setUpdateValues([]);
    setAddedUsers({});
    currentTabOption === "prod" ? setProdUsers(originalData) : setUATUsers(originalData);
  };
  const normalizeRegionCode = (code: string | number | null | undefined) => {
  if (code === null || code === undefined || code === "") return "";
  return String(code).padStart(2, "0");
};

  /** Update/save billing details */
  const saveBillingDetails = async () => {
    // if (billingDetails?.address?.length == 0 || billingDetails?.gstin?.length == 0 || billingDetails?.pan?.length == 0 || billingDetails?.signatory?.length == 0) {
    //   setErrMessage('All fields are mandatory.')
    //   return
    // }

    setErrMessage("");
    if (editableBillingFields.pan === true && (billingDetails.pan.length !== 10 || !isAlphaNumeric(billingDetails.pan))) {
      setErrMessage("Invalid pan number.");
      return;
    } else if (editableBillingFields.address === true && (billingDetails.address.length < 10 || !billingDetails.address.match(/[A-Za-z0-9.,/-\s]+$/))) {
      billingDetails.address.length < 10 ? setErrMessage("Invalid address.") : setErrMessage("Provided address contains unexpected special characters.");
      return;
    } else if (editableBillingFields.gstin === true && (billingDetails.gstin.length < 12 || !isAlphaNumeric(billingDetails.gstin))) {
      setErrMessage("Invalid GSTIN number.");
      return;
    } else if (editableBillingFields.signatory === true && (billingDetails.signatory.length < 3 || !billingDetails.signatory.match(/[A-Za-z\s]+$/))) {
      setErrMessage("Invalid name format.");
      return;
    }

    if (!Object.values(editableBillingFields).includes(true)) {
      discardChanges();
      return;
    }

    dispatch(showLoader(message.UPDATING_DETAILS));
    const payload = {
      pan: billingDetails.pan,
      gstin: billingDetails.gstin,
      billing_address: billingDetails.address,
      authorised_signatory: billingDetails.signatory,
    };

    const response = await postDetails(APIList.USER_SAVE_BILLING_DETAILS, payload, saveBillingDetails);

    dispatch(hideLoader());

    if (response.statusCode === APIResponseCodes.SUCCESS) {
      setEditableBillingFields({ address: false, gstin: false, pan: false, signatory: false });
      setBillingDetails({
        address: response.data.billing_address,
        gstin: response.data.gstin,
        pan: response.data.pan,
        signatory: response.data.authorised_signatory,
      });
      setbillingCopyFormInputs({
        address: response.data.billing_address,
        gstin: response.data.gstin,
        pan: response.data.pan,
        signatory: response.data.authorised_signatory,
      });
    }
  };

  const validateInputType = (ev: any) => {
    let val = parseInt(ev.target.value);
    if (isNaN(val)) {
      ev.target.value = "";
      return;
    }
    ev.target.value = val;
  };

  const toggleTokenVisibility = (id: "1" | "2") => {
    if (id === "1") {
      setShowUATToken({ ...showUATToken, show: !showUATToken.show });
    }

    if (id === "2") {
      setShowProdToken({ ...showProdToken, show: !showProdToken.show });
    }
  };

  const copyToken = async (id: "1" | "2") => {
    if (id === "1") {
      setShowUATToken({ ...showUATToken, copied: true });
      if (window.isSecureContext) {
        await navigator.clipboard.writeText(`uat_${showUATToken.token}`);
      }
      setTimeout(() => {
        setShowUATToken({ ...showUATToken, copied: false });
      }, 1500);
    }

    if (id === "2") {
      setShowProdToken({ ...showProdToken, copied: true });
      if (window.isSecureContext) {
        await navigator.clipboard.writeText(`prod_${showProdToken.token}`);
      }
      setTimeout(() => {
        setShowProdToken({ ...showProdToken, copied: false });
      }, 1500);
    }
  };

//   const selectedRegion = regionCodes.find(
//   (region) => normalizeRegionCode(region.region_code) === normalizeRegionCode(complianceDetails.region_code)
// );

  return (
    <MainContainer>
      <Breadcrumb routes={BreadcrumbData.profile} />
      
      <h2 className="text-capitalize mf-active-header">Profile</h2>

      <div className="profile-main-content mb-5">
        <div className="profile-tabs d-flex">
          {options.map((item, index) => (
            <p data-focused={item.id === tabOptions.id} className="mb-0 profile-tab cursor-pointer text-capitalize font-14 weight-500 me-3" key={index} onClick={() => handleSelection(item)}>
              {item.label}
            </p>
          ))}
          {(access.hasProdAccess || access.hasUATAccess) && (
            <p data-focused={tabOptions.id === 4} className="mb-0 profile-tab cursor-pointer text-capitalize font-14 weight-500 me-3" onClick={() => handleSelection({ id: 4, label: "Support" })}>
              Support
            </p>
          )}
          {primaryUser && (
            <p
              data-focused={tabOptions.id === 5}
              className="mb-0 profile-tab cursor-pointer text-capitalize font-14 weight-500 me-3"
              onClick={() => handleSelection({ id: 5, label: "Manage Access" })}
            >
              Manage Access
            </p>
          )}
        </div>

        {tabOptions.id === 1 && (
          <div className="card-shadow mt-4 card-padding bg-white profile-general">
            <div className="d-flex align-items-center justify-content-between profile-general-org">
              <div className="profile-input pe-2 custom-scrollbar profile-org-overflow">{generalFormInputs.organisation_name}</div>
            </div>

            <div className="row no-negative-margin mt-4 profile-input-sections">
              <div className="ps-0 personal-details">
                <p className="mb-0 text-capitalize text-sec-color font-14 weight-600">Contact Details</p>

                <div className="row-inputs d-flex mt-4">
                  <label className="text-capitalize font-13 weight-400 row-input-label">Email Address</label>
                  <InputField
                    name="email"
                    type="text"
                    value={generalFormInputs.email}
                    placeholder={user?.email}
                    className="profile-input"
                    containerClassName="profile-input-container"
                    maxLength={100}
                    minLength={3}
                    pattern="[A-Za-z.\s]+"
                    showErrors={false}
                    disabled
                  />
                </div>
                <div className="row-inputs d-flex mt-4">
                  <label className="text-capitalize font-13 weight-400 row-input-label">Phone number</label>
                  <div className="position-relative">
                    {!editableFields.phone_number && <button type="button" className="btn-input-pencil border-0" name="phone_number" onClick={handleInputEdit}></button>}
                    <div className="d-block">
                      <input
                        type="text"
                        data-editable={editableFields.phone_number}
                        disabled={!editableFields.phone_number}
                        className="mf-admin-inputfield profile-input profile-input-editable"
                        name="phone_number"
                        maxLength={10}
                        minLength={10}
                        pattern="[0-9+\s]+"
                        value={generalFormInputs.phone_number}
                        onChange={(ev) => setInputValues(ev, generalFormInputs, setGeneralFormInputs)}
                        {...bindValue("phone_number")}
                        onInput={validateInputType}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="pe-0 compliance-details">
                <p className="mb-0 text-capitalize text-sec-color font-14 weight-600">Compliance Details</p>

                {user.registered_with_sebi && (
                  <div className="row-inputs row-inputs-required d-flex mt-4">
                    <label className="text-capitalize font-13 weight-400 row-input-label">ARN/RIA/EOP</label>
                    <div className="position-relative">
                      {primaryUser && !editableComplianceFields.arn && <button type="button" className="btn-input-pencil border-0" name="arn" onClick={handleInputEdit}></button>}
                      <input
                        type="text"
                        data-editable={editableComplianceFields.arn}
                        disabled={!editableComplianceFields.arn}
                        // placeholder={user?.sebi_code || "Ex: 1390 3093 5930"}
                        placeholder={user?.sebi_code || "Select ARN/RIA/EOP"}
                        className="mf-admin-inputfield profile-input profile-input-editable"
                        name="arn"
                        maxLength={13}
                        minLength={7}
                        // pattern="^[Aa][Rr][Nn]-[0-9]{4,6}$"
                        pattern="^(ARN|INA|EOP)-?\d+$/i"
                        value={complianceDetails.arn}
                        onChange={(ev) => setInputValues(ev, complianceDetails, setComplianceDetails)}
                        {...bindValue("arn")}
                      />
                    </div>
                  </div>
                )}
                {/* {
                  user.registered_with_rbi &&
                  <div className="row-inputs d-flex mt-4 justify-content-end position-relative">
                    <label className="text-capitalize font-13 weight-400 row-input-label">RIA Code</label>
                    <div className="position-relative">
                      {
                        primaryUser && !editableFields.ria &&
                        <button
                          type="button"
                          className="btn-input-pencil border-0"
                          name="ria"
                          onClick={handleInputEdit}
                        ></button>
                      }
                      <input
                        type="text"
                        data-editable={editableFields.ria}
                        disabled={!editableFields.ria}
                        className="mf-admin-inputfield profile-input profile-input-editable"
                        name="ria"
                        maxLength={8}
                        minLength={8}
                        pattern="[A-Za-z0-9\s]+"
                        value={generalFormInputs.ria}
                        placeholder={user?.rbi_code || 'Ex: 1390 3093 5930'}
                        onChange={(ev) => setInputValues(ev, generalFormInputs, setGeneralFormInputs)}
                        {...bindValue('ria')}
                      />
                    </div>
                  </div>
                } */}
                {/* <div className="row-inputs d-flex mt-4 justify-content-end position-relative">
                  <label className="text-capitalize font-13 weight-400 row-input-label position-relative">PAN</label>
                  <div className="position-relative">
                    {
                      !editableFields.pan &&
                      <button
                        type="button"
                        className="btn-input-pencil border-0"
                        name="pan"
                        onClick={handleInputEdit}
                      ></button>
                    }
                    <input
                      type="text"
                      data-editable={editableFields.pan}
                      disabled={!editableFields.pan}
                      className="mf-admin-inputfield profile-input profile-input-editable"
                      name="pan"
                      maxLength={10}
                      minLength={10}
                      pattern="[A-Za-z0-9]+"
                      value={generalFormInputs.pan}
                      placeholder="Ex: EPSJA0294K"
                      onChange={(ev) => setInputValues(ev, generalFormInputs, setGeneralFormInputs)}
                      {...bindValue('pan')}
                    />
                  </div>
                </div> */}

                {/* //-- General Tab arn/ria/eop, pan, gst Billing Information --// */}
                <div className="row-inputs row-inputs-required d-flex mt-2">
                  <label className="text-capitalize font-13 weight-400 row-input-label position-relative">PAN</label>
                  <div className="position-relative">
                    {primaryUser && !editableComplianceFields.pan && <button type="button" className="btn-input-pencil border-0" name="pan" onClick={handleInputEdit}></button>}
                    <div className="d-block">
                      <input
                        type="text"
                        data-editable={editableComplianceFields.pan}
                        disabled={!editableComplianceFields.pan}
                        className="mf-admin-inputfield profile-input profile-input-editable"
                        name="pan"
                        // placeholder="ETCA9026H"
                        placeholder="Select PAN"
                        maxLength={10}
                        minLength={10}
                        pattern="[A-Za-z0-9]+"
                        value={complianceDetails.pan}
                        onChange={(ev) => setInputValues(ev, complianceDetails, setComplianceDetails)}
                        {...bindValue("pan")}
                      />
                    </div>
                  </div>
                </div>
                <div className="row-inputs d-flex mt-4">
                  <label className="text-capitalize font-13 weight-400 row-input-label">GSTIN</label>
                  <div className="position-relative">
                    {primaryUser && !editableComplianceFields.gstin && <button type="button" className="btn-input-pencil border-0" name="gstin" onClick={handleInputEdit}></button>}
                    <div className="d-block">
                      <input
                        type="text"
                        data-editable={editableComplianceFields.gstin}
                        disabled={!editableComplianceFields.gstin}
                        className="mf-admin-inputfield profile-input profile-input-editable"
                        name="gstin"
                        // placeholder="192ETCA9026H21"
                        placeholder="Select GSTIN"
                        maxLength={15}
                        minLength={12}
                        pattern="[A-Za-z0-9]+"
                        value={complianceDetails.gstin}
                        onChange={(ev) => setInputValues(ev, complianceDetails, setComplianceDetails)}
                        {...bindValue("gstin")}
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="row-inputs row-inputs-required d-flex mt-4">
                  <label className="text-capitalize font-13 weight-400 row-input-label">Region Code</label>
                  <div className="position-relative profile-region-dropdown">
                    {primaryUser && !editableComplianceFields.region_code && (
                      <button type="button" className="btn-input-pencil border-0" name="region_code" onClick={handleInputEdit}></button>
                    )}

                    <button
  type="button"
  data-editable={editableComplianceFields.region_code}
  className="mf-admin-inputfield profile-input profile-input-editable profile-region-select"
  onClick={() => {
    if (!editableComplianceFields.region_code) return;
    setShowRegionDropdown(!showRegionDropdown);
  }}
>
                      {selectedRegion ? `${selectedRegion.state_name} - ${selectedRegion.region_code}` : "Select Region"}
                    </button>

                    {editableComplianceFields.region_code && showRegionDropdown && (
                      <div className="profile-region-menu">
                        <button
                          type="button"
                          className="profile-region-option"
                          onClick={() => {
                            setComplianceDetails({ ...complianceDetails, region_code: "" });
                            setShowRegionDropdown(false);
                          }}
                        >
                          Select Region
                        </button>

                        {regionCodes.map((region) => (
                          <button
                            type="button"
                            key={region.id}
                            className="profile-region-option"
                            onClick={() => {
                              setComplianceDetails({
                                ...complianceDetails,
                                region_code: normalizeRegionCode(region.region_code),
                              });
                              setShowRegionDropdown(false);
                            }}
                          >
                            {region.state_name} - {region.region_code}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div> */}
              </div>
            </div>

            {
              /* Exclusive action bar: compliance takes precedence */
              (() => {
                const hasComplianceEdits = Object.values(editableComplianceFields).includes(true);
                const hasGeneralEdits = Object.values(editableFields).includes(true);

                if (hasComplianceEdits) {
                  return (
                    <div className="text-center mt-5">
                      {errMessage.length !== 0 && <p className="mb-0 font-14 error-text-color weight-500 mb-3">{errMessage}</p>}
                      <div className="mb-3 w-25 mx-auto d-flex gen-submit-actions">
                        <CustomButton theme="outlined" onClick={discardChanges} type="button">
                          Discard
                        </CustomButton>
                        <CustomButton disabled={!showComplianceSubmitBtn} onClick={saveComplianceGeneralDetails} type="button">
                          Update
                        </CustomButton>
                      </div>
                    </div>
                  );
                }

                if (hasGeneralEdits) {
                  return (
                    <div className="text-center mt-5">
                      {errMessage.length !== 0 && <p className="mb-0 font-14 error-text-color weight-500 mb-3">{errMessage}</p>}
                      <div className="mb-3 w-25 mx-auto d-flex gen-submit-actions">
                        <CustomButton theme="outlined" onClick={discardChanges} type="button">
                          Discard
                        </CustomButton>
                        <CustomButton disabled={!showGenSubmitBtn} onClick={saveUserGeneralDetails} type="button">
                          Update
                        </CustomButton>
                      </div>
                    </div>
                  );
                }

                return null;
              })()
            }

            <p className="mb-0 text-capitalize text-black font-14 weight-600 mt-3 mt-lg-4">Access Tokens</p>

            <div className="d-flex mb-2">
              <div className="row-inputs d-flex mt-4">
                <p className="mb-0 text-capitalize text-primary-color font-12 weight-400 row-input-label">UAT Token</p>
                <div className="token-container d-flex align-items-center">
                  <p className="mb-0 font-14">{showUATToken.show ? `uat_${showUATToken.token}` : "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"}</p>
                  {showUATToken.token && (
                    <button onClick={() => toggleTokenVisibility("1")} data-active={showUATToken.show} type="button" className="ms-3 eye-toggle-btn">
                      <img width={15} src={eyeIcon} alt="show" className="vert-middle" />
                    </button>
                  )}
                  {showUATToken.token && (
                    <button data-active={showUATToken.copied} onClick={() => copyToken("1")} type="button" className={`border-0 ms-2 bg-white ${showUATToken.copied ? "copied" : ""}`}>
                      <div className="sec-key-container py-1 px-2">
                        <p className="mb-0 text-captalize font-14 text-black text-capitalize">{showUATToken.copied ? "copied" : "Copy"}</p>
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex">
              <div className="row-inputs d-flex mt-4">
                <p className="mb-0 text-capitalize text-primary-color font-12 weight-400 row-input-label">Prod Token</p>
                <div className="token-container d-flex align-items-center">
                  <p className="mb-0 font-14">{showProdToken.show ? `prod_${showProdToken.token}` : "XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX"}</p>
                  {showProdToken.token && (
                    <button onClick={() => toggleTokenVisibility("2")} data-active={showProdToken.show} type="button" className="ms-3 eye-toggle-btn">
                      <img width={15} src={eyeIcon} alt="show" className="vert-middle" />
                    </button>
                  )}
                  {showProdToken.token && (
                    <button data-active={showProdToken.copied} onClick={() => copyToken("2")} type="button" className={`border-0 ms-2 bg-white ${showProdToken.copied ? "copied" : ""}`}>
                      <div className="sec-key-container py-1 px-2">
                        <p className="mb-0 text-captalize font-14 text-black text-capitalize">{showProdToken.copied ? "copied" : "Copy"}</p>
                      </div>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {tabOptions.id === 2 && (
          <div className="mt-3 p-4 bg-white">
            <p className="mb-0 text-capitalize font-14 weight-600 text-sec-color">Order summary</p>
            <Orders />
          </div>
        )}

        {tabOptions.id === 3 && (
          <div className="mt-4">
            <p className="mb-0 text-capitalize font-14 weight-600 text-sec-color mb-3">Billing Information</p>
            <div className="card-shadow card-padding bg-white">
              <div className="row no-negative-margin profile-input-sections">
                <div className="ps-0 personal-details">
                  <div className="row-inputs row-inputs-required d-flex mt-2">
                    <label className="text-capitalize font-13 weight-400 row-input-label position-relative">PAN</label>
                    <div className="position-relative">
                      {primaryUser && !editableBillingFields.pan && <button type="button" className="btn-input-pencil border-0" name="pan" onClick={handleInputEdit}></button>}
                      <div className="d-block">
                        <input
                          type="text"
                          data-editable={editableBillingFields.pan}
                          disabled={!editableBillingFields.pan}
                          className="mf-admin-inputfield profile-input profile-input-editable"
                          name="pan"
                          // placeholder="ETCA9026H"
                          placeholder="Enter PAN"
                          maxLength={10}
                          minLength={10}
                          pattern="[A-Za-z0-9]+"
                          value={billingDetails.pan}
                          onChange={(ev) => setInputValues(ev, billingDetails, setBillingDetails)}
                          {...bindValue("pan")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row-inputs row-inputs-required d-flex mt-4">
                    <label className="text-capitalize font-13 weight-400 row-input-label">GSTIN</label>
                    <div className="position-relative">
                      {primaryUser && !editableBillingFields.gstin && <button type="button" className="btn-input-pencil border-0" name="gstin" onClick={handleInputEdit}></button>}
                      <div className="d-block">
                        <input
                          type="text"
                          data-editable={editableBillingFields.gstin}
                          disabled={!editableBillingFields.gstin}
                          className="mf-admin-inputfield profile-input profile-input-editable"
                          name="gstin"
                          // placeholder="192ETCA9026H21"
                          placeholder="Enter GSTIN"
                          maxLength={15}
                          minLength={12}
                          pattern="[A-Za-z0-9]+"
                          value={billingDetails.gstin}
                          onChange={(ev) => setInputValues(ev, billingDetails, setBillingDetails)}
                          {...bindValue("gstin")}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="pe-0 compliance-details">
                  <div className="row-inputs row-inputs-required d-flex mt-2">
                    <label className="text-capitalize font-13 weight-400 row-input-label">Billing address</label>
                    <div className="position-relative">
                      {primaryUser && !editableBillingFields.address && <button type="button" className="btn-input-pencil border-0" name="address" onClick={handleInputEdit}></button>}
                      <div className="d-block">
                        <input
                          type="text"
                          data-editable={editableBillingFields.address}
                          disabled={!editableBillingFields.address}
                          className="mf-admin-inputfield profile-input profile-input-editable"
                          name="address"
                          // placeholder="12, 6th floor, skyview apart..."
                          placeholder="Enter Billing Address"
                          maxLength={200}
                          minLength={10}
                          pattern="[A-Za-z0-9.,/-\s]+"
                          value={billingDetails.address}
                          onChange={(ev) => setInputValues(ev, billingDetails, setBillingDetails)}
                          {...bindValue("address")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row-inputs row-inputs-required d-flex mt-4">
                    <label className="text-capitalize font-13 weight-400 row-input-label">Authorised Signatory</label>
                    <div className="position-relative">
                      {primaryUser && !editableBillingFields.signatory && <button type="button" className="btn-input-pencil border-0" name="signatory" onClick={handleInputEdit}></button>}
                      <div className="d-block">
                        <input
                          type="text"
                          data-editable={editableBillingFields.signatory}
                          disabled={!editableBillingFields.signatory}
                          className="mf-admin-inputfield profile-input profile-input-editable"
                          name="signatory"
                          // placeholder="Ex : Anil Kumar"
                          placeholder="Enter signatory"
                          maxLength={50}
                          minLength={3}
                          pattern="[A-Za-z\s]+"
                          value={billingDetails.signatory}
                          onChange={(ev) => setInputValues(ev, billingDetails, setBillingDetails)}
                          {...bindValue("signatory")}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {Object.values(editableBillingFields).includes(true) && (
                <div className="text-center mt-5">
                  {errMessage.length !== 0 && <p className="mb-0 font-14 error-text-color weight-500 mb-3">{errMessage}</p>}
                  <div className="mb-3 w-25 mx-auto d-flex gen-submit-actions">
                    <CustomButton theme="outlined" onClick={discardChanges} type="button">
                      Discard
                    </CustomButton>
                    <CustomButton disabled={JSON.stringify(billingDetails) === JSON.stringify(billingCopyFormInputs)} onClick={saveBillingDetails} type="button">
                      Update
                    </CustomButton>
                  </div>
                </div>
              )}
            </div>

            <p className="mb-0 text-capitalize font-14 weight-600 text-sec-color mt-4 mb-3">Invoices</p>

            <Invoices />

            <div className="profile-agreements">
              <p className="mb-0 text-capitalize font-14 weight-600 text-sec-color mt-4 mb-3">Agreement</p>

              {allAgreements.map((agreement, index) => (
                <div key={index} className="profile-invoices">
                  <div className="mf-listing-card-container bg-white">
                    <div className="d-flex mf-common-card p-3 position-relative">
                      <button className="d-block d-md-none d-lg-none agreement-info text-balck border-0 weight-700 position-absolute" type="button">
                        {" "}
                        i{" "}
                      </button>
                      <div className="">
                        <p className="mb-0 text-primary-color font-16 weight-500">
                          <strong className="text-primary-color weight-500 text-uppercase">{`${agreement.api_type}`}</strong>
                        </p>
                        <p className="mb-0 font-16 weight-400 mf-listing-api-desc mt-1">Effective since {formatDate(agreement.updated_at, "fullmonth")}</p>
                      </div>
                      <div className="col-12 col-md-6 col-lg-6 ps-0 d-flex checkout-card-actions card-status-right pe-0 position-relative">
                        <button onClick={() => setFileToView(agreement.doc)} className="download-btn border-0 bg-white me-3">
                          <img width={15} height={15} src={eyeIcon} alt="view" />
                        </button>

                        <button onClick={() => openURL(agreement.doc, "download", ``)} className="download-btn border-0 bg-white me-4">
                          <img width={15} height={15} src={downloadIcon} alt="download" />
                        </button>

                        <button type="button" className="card-status-btn text-capitalize card-status-btn-processed font-14 weight-600 me-3">
                          Effective
                        </button>
                        <button className="d-none d-md-block d-lg-block agreement-info text-balck border-0 weight-700 position-absolute" type="button">
                          {" "}
                          i{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {allAgreements.length === 0 && (
                <div className="mf-listing-card-container bg-white px-3 py-4">
                  <p className="mb-0 font-13 text-center weight-500 text-primary-color">No Agreements are added or effective...</p>
                </div>
              )}
            </div>
          </div>
        )}

        {tabOptions.id === 4 && (access.hasProdAccess || access.hasUATAccess) && <Requests showHeaderFooter={false} />}

        {primaryUser && tabOptions.id === 5 && (
          <div className="">
            <div className="mt-4">
              <div className="card-shadow p-3 bg-white">
                {!canAddUsers && (
                  <div className="mb-4">
                    <InfoCard message="You need to place at least one successful order to add more users..." status="warning" />
                  </div>
                )}

                <div className="mf-access-control d-flex align-items-start justify-content-between mb-4">
                  <div className="access-control-header">
                    <p className="mb-1 text-capitalize font-14 weight-600">{currentTabOption === "uat" ? "UAT Order Access" : "Production Order Access"}</p>
                    <p className="mb-0 text-capitalize font-13 weight-400">Lorem ipsum dolor sit amet consectetur adipisicing elit. Officiis aliquam maxime</p>
                  </div>
                  <div className="orders-prod-toggle mb-0 mt-0">
                    <button onClick={() => changeTab("uat")} data-selected={currentTabOption === "uat"} className="prod-toggle-live border-0 font-14 text-capitalize weight-500">
                      UAT
                    </button>
                    <button onClick={() => changeTab("prod")} data-selected={currentTabOption === "prod"} className="prod-toggle-prod border-0 font-14 text-capitalize weight-500">
                      Production
                    </button>
                  </div>
                </div>
                <div className="py-3">
                  <div className="d-flex new-user-input-section">
                    <div className="manage-add-user-input position-relative w-100">
                      <input
                        // placeholder="Ex: user@domain.com"
                        placeholder="Enter Email"
                        type="email"
                        className="mf-admin-inputfield profile-input profile-input-editable w-100"
                        name={"user_email"}
                        maxLength={100}
                        minLength={10}
                        pattern="^[a-zA-Z0-9._%+-]+[a-zA-Z0-9]+@[a-z0-9.-]+\.[a-zA-Z]{2,4}"
                        value={newUser.value}
                        onChange={(ev) => {
                          setNewUser({ ...newUser, value: ev.target.value });
                          setErr({ show: false, message: "" });
                        }}
                        {...bindValue("user_email")}
                      />
                      {accessUpdateMode.active && (
                        <button className="border-0 bg-white position-absolute" onClick={resetUpdate}>
                          <img width={18} height={18} src={closeIcon} alt="close" />
                        </button>
                      )}
                    </div>
                    <button
                      onClick={handleAddField}
                      className="border-0 primary-bg-color text-white font-13 profile-add-user-btn text-center ms-2 ms-md-4 ms-lg-4"
                      disabled={!canAddUsers || newUser.value.length === 0}
                    >
                      {accessUpdateMode.active ? "Update" : "Add User"}
                    </button>
                  </div>
                  {err.show && <p className="mb-3 error-text-color font-13">{err.message}</p>}
                </div>
                <table className="mf-table mf-access-control-table table-responsive w-100">
                  <thead className="mf-table-head access-table-head">
                    <tr className="mf-table-head-row">
                      <th className="font-13 weight-500 text-capitalize ps-3">No.</th>
                      <th className="font-13 weight-500 text-capitalize">Email ID</th>
                      <th className="font-13 weight-500 text-capitalize text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="mf-table-body access-table-body">
                    {currentItems.length !== 0 &&
                      currentItems.map((usr: any, index) => (
                        <tr className="mf-table-body-row" key={index}>
                          <td className="font-13 weight-400 ps-3">{index + 1 + itemOffset}</td>
                          <td className="font-13 weight-400">{usr.email || ""}</td>
                          <td className="text-center ps-2 profile-actions">
                            <button className="border-0 me-3" onClick={() => handleUserEdit(usr)}>
                              <img width={15} height={15} src={editPencil} alt="edit" />
                            </button>
                            <button className="border-0" onClick={() => handleFieldDelete(usr)}>
                              <img width={15} height={15} src={deleteIcon} alt="delete" />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                {currentTabOption === "uat" && uatUsers.length === 0 && <p className="mb-0 font-14 py-3 primary-text-color text-center">No users found...</p>}
                {currentTabOption === "prod" && prodUsers.length === 0 && <p className="mb-0 font-14 py-3 primary-text-color text-center">No users found...</p>}
                {(updateValues.length !== 0 || Object.keys(addedUsers).length !== 0) && (
                  <div className="mb-3 mt-5 w-25 mx-auto d-flex gen-submit-actions mb-5">
                    <CustomButton theme="outlined" onClick={discardAccessChanges} type="button">
                      Discard
                    </CustomButton>
                    <CustomButton onClick={handleUsersSubmit} type="button">
                      Save Changes
                    </CustomButton>
                  </div>
                )}

                {
                  <div className="mt-2">
                    <CustomPagination handlePageClick={handlePageClick} itemsPerPage={itemsPerPage} pageCount={pageCount} pageNumber={pageNumber - 1} />
                  </div>
                }
              </div>
            </div>
          </div>
        )}
      </div>
      <Alert proceedCallback={deleteUser} />
      {fileToView.length !== 0 && <CustomDocViewer url={fileToView} uploadedFile={null} onClose={() => setFileToView("")} />}
    </MainContainer>
  );
};

export default ProfilePage;
